import React, { useEffect, useMemo, useState } from "react";
import { CardContainer } from "../../components/Card/CardContainer";
import PageTitleNested from "../../components/PageTitle/PageTitleNested";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import { useNavigate } from "react-router";
import { Card, Col, ConfigProvider, Input, Row, Select, Table, Tag } from "antd";
import Text from "../../components/Text/Text";
import Button from "../../components/Button/Button";
import { FlexCol, FlexRow } from "../../components/Container/Container";
import { getFlashSaleTrackingRoundEachShop } from "../../datasource/FlashSaleDatasource";
import dayjs from "dayjs";
import { numberFormatter } from "../../utility/Formatter";
import { mapQuotaType } from "../../definitions/flashSaleStatus";
import { SearchOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { ORDER_STATUS } from "../../definitions/orderStatus";
import { getOrderStatus } from "../../utility/OrderStatus";
import { ActionBtn } from "../../components/Button/TableActionButton";
import image from "../../resource/image";

export const TrackingFlashSaleShop = () => {
  const profile = JSON.parse(localStorage.getItem("profile")!);
  const digitDecimal = profile?.company === "ICPL" ? 0 : 2;
  const { pathname } = window.location;
  const pathSplit = pathname.split("/") as Array<string>;
  const flashSaleId = pathSplit[5];
  const cusComId = pathSplit[6];
  const round = pathSplit[7]; //round uuid;
  const roundNo = pathSplit[8];
  const navigate = useNavigate();
  const [data, setData] = useState<any>();
  const [currentRound, setCurrentRound] = useState(roundNo || "ALL");
  const [roundId, setRoundId] = useState<any>(round === "undefined" ? "ALL" : round);

  const fetchEachShop = async () => {
    const { responseData } = await getFlashSaleTrackingRoundEachShop({
      flashSaleId: flashSaleId,
      customerCompanyId: Number(cusComId),
      ...(roundId !== "ALL" && { flashSaleRoundId: roundId }),
    });
    setData(responseData);
  };

  useEffect(() => {
    fetchEachShop();
  }, [roundId]);

  const infoDashboard = [
    {
      label: "ยอดสั่งซื้อรวม",
      description: "ยอดจริงได้รับการยืนยัน",
      value: `${numberFormatter(data?.summary?.totalSales || 0, 2)} ฿`,
      percentage: null,
      bgColor: null,
      hidden: false,
    },
    {
      label: "จำนวนที่ซื้อ (หน่วย)",
      description: "ออเดอร์ที่ร้านยืนยันคำสั่งซื้อ",
      value: numberFormatter(data?.summary?.soldUnits || 0, digitDecimal),
      percentage: null,
      bgColor: null,
      hidden: false,
    },
    {
      label: "ออเดอร์ทั้งหมด (รายการ)",
      description: "รวมทุกสถานะ ไม่รวมออเดอร์ยกเลิก",
      value: numberFormatter(data?.summary?.orderCount || 0, 0),
      percentage: null,
      bgColor: null,
      hidden: false,
    },
  ];

  const PageTitle = () => {
    return (
      <PageTitleNested
        title=' รายละเอียด Flash Sale'
        customBreadCrumb={
          <BreadCrumb
            data={[
              {
                text: "รายการ Flash Sale",
                path: "/PromotionPage/flashSale",
              },
              {
                text: "รายละเอียด Flash Sale",
                path: `/PromotionPage/detailFlashSale/${flashSaleId}/tracking`,
              },
              {
                text: "ภาพรวมทั้งแคมเปญ",
                path: `/PromotionPage/detailFlashSale/tracking/${flashSaleId}/${round === "undefined" ? "ALL" : round}`,
              },
              {
                text: "รายละเอียดรายร้าน",
                path: window.location.pathname,
              },
            ]}
          />
        }
        onBack={() =>
          navigate(
            "/PromotionPage/detailFlashSale/tracking/" +
              flashSaleId +
              "/" +
              (round === "undefined" ? "ALL" : round),
          )
        }
      />
    );
  };
  const CardShopInfo = () => {
    return (
      <Card bodyStyle={{ padding: "16px", backgroundColor: "#FAFAFA" }}>
        <div style={{ marginBottom: "16px" }}>
          <Text fontWeight={700}>ข้อมูลร้านค้า</Text>
        </div>
        <Row justify='start' gutter={16} style={{ marginBottom: "8px" }}>
          <Col span={3}>
            <Text color='Text3'>รหัสร้านค้า</Text>
          </Col>
          <Col>
            <Text>{data?.shop?.customerNo}</Text>
          </Col>
        </Row>
        <Row justify='start' gutter={16} style={{ marginBottom: "8px" }}>
          <Col span={3}>
            <Text color='Text3'>ชื่อร้านค้า</Text>
          </Col>
          <Col>
            <Text>{data?.shop?.customerName}</Text>
          </Col>
        </Row>
        <Row justify='start' gutter={16} style={{ marginBottom: "8px" }}>
          <Col span={3}>
            <Text color='Text3'>เขต</Text>
          </Col>
          <Col>
            <Text>{data?.shop?.zone}</Text>
          </Col>
        </Row>
        <Row justify='start' gutter={16} style={{ marginBottom: "8px" }}>
          <Col span={3}>
            <Text color='Text3'>กลุ่มลูกค้า</Text>
          </Col>
          <Col>
            <Text>{data?.shop?.customerGroupName}</Text>
          </Col>
        </Row>
      </Card>
    );
  };

  return (
    <CardContainer>
      <PageTitle />
      <br />
      <CardShopInfo />
      <br />
      <div style={{ marginBottom: "16px" }}>
        <Text fontWeight={700} level={4}>
          รายละเอียดตามรอบ
        </Text>
      </div>
      <div style={{ marginBottom: "16px" }}>
        <Text color='Text3' level={6}>
          อัปเดตล่าสุด{" "}
          {dayjs(data?.fetchedAt).locale("th").add(543, "year").format("DD MMM YYYY • HH:mm:ss")}
        </Text>
      </div>
      <Row justify={"start"} gutter={16}>
        <Col>
          <Button
            title='ทั้งแคมเปญ'
            height={32}
            typeButton={currentRound === "ALL" ? "navy-blue" : "light-navy-blue"}
            onClick={() => {
              setRoundId("ALL");
              setCurrentRound("ALL");
            }}
          />
        </Col>
        {data?.rounds?.map((item) => (
          <Col key={item.roundNo}>
            <Button
              title={`รอบที่ ${item.roundNo}`}
              height={32}
              typeButton={
                currentRound === item.roundNo.toString() ? "navy-blue" : "light-navy-blue"
              }
              onClick={() => {
                setRoundId(item.flashSaleRoundId);
                setCurrentRound(item.roundNo.toString());
              }}
            />
          </Col>
        ))}
      </Row>
      <br />
      <Row justify={"start"} gutter={16}>
        <Col>
          <Text color='Text3' level={6}>
            {(() => {
              const findDate = data?.rounds.find(
                (round: any) => round.roundNo.toString() === currentRound,
              );
              const startDate = findDate
                ? dayjs(findDate.startDate)
                    .locale("th")
                    .add(543, "year")
                    .format("DD MMM YYYY (HH:mm)")
                : dayjs(data?.startDate)
                    .locale("th")
                    .add(543, "year")
                    .format("DD MMM YYYY (HH:mm)");
              const endDate = findDate
                ? dayjs(findDate.endDate)
                    .locale("th")
                    .add(543, "year")
                    .format("DD MMM YYYY (HH:mm)")
                : dayjs(data?.endDate).locale("th").add(543, "year").format("DD MMM YYYY (HH:mm)");
              return (
                <>
                  รอบการจัดแคมเปญ &nbsp;&nbsp;
                  <Text level={6}>
                    {startDate} - {endDate}
                  </Text>
                </>
              );
            })()}
          </Text>
        </Col>
      </Row>
      <br />
      <Row justify='space-between' gutter={16}>
        {infoDashboard?.map((item: any, index) => (
          <>
            <Col
              span={24 / (infoDashboard?.filter((item: any) => !item.hidden).length || 1)}
              key={index}
            >
              <Card bodyStyle={{ padding: 12 }} style={{ backgroundColor: item.bgColor }}>
                <FlexCol>
                  <Text color='Text3'>{item.label}</Text>
                  <Text fontSize={38} fontWeight={700}>
                    {item.value}{" "}
                    {item.percentage && (
                      <Text color='primary' fontWeight={700}>
                        {item.percentage}
                      </Text>
                    )}
                  </Text>
                  <Text color={index === 3 ? "BK" : "Text3"} fontWeight={index === 3 ? 700 : 400}>
                    {item.description}
                  </Text>
                </FlexCol>
              </Card>
            </Col>
          </>
        ))}
      </Row>
      <br />
      <SectionProduct data={data?.products || []} company={profile?.company} />
      <br />
      <SectionOrderShop
        data={data?.orders || []}
        company={profile?.company}
        rounds={data?.rounds || []}
        currentRound={currentRound}
      />
    </CardContainer>
  );
};

const SectionProduct = ({ data, company }: { data: Array<any>; company: string }) => {
  const digitDecimal = company === "ICPL" ? 0 : 2;
  const columns = [
    {
      title: "#",
      dataIndex: "no",
      key: "no",
      width: "5%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{index + 1}</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ชื่อสินค้า",
      dataIndex: "productName",
      key: "productName",
      width: "30%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{value}</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ขนาด",
      dataIndex: "packSize",
      key: "packSize",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{value}</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "รูปแบบโควตา",
      dataIndex: "quotaType",
      key: "quotaType",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Tag color='#EFF2F9'>
                <Text level={6} fontWeight={700}>
                  {mapQuotaType[value]}
                </Text>
              </Tag>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ยอดสั่งซื้อ (฿)",
      dataIndex: "salesAmount",
      key: "salesAmount",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{numberFormatter(value, 2)} ฿</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "จำนวนที่ซื้อ (หน่วย)",
      dataIndex: "soldUnits",
      key: "soldUnits",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexRow justify='start'>
              <Text>
                {numberFormatter(value, digitDecimal)}{" "}
                {row.shopQuota && `/${numberFormatter(row.shopQuota, digitDecimal)}`}
              </Text>{" "}
              &nbsp;&nbsp;
              <Text>{row.saleUomTh}</Text>
            </FlexRow>
          ),
        };
      },
    },
  ];

  return (
    <>
      <Row justify={"space-between"} gutter={16} style={{ marginBottom: 16 }}>
        <Col>
          <Text fontWeight={700}>ยอดสั่งซื้อสินค้า</Text>
        </Col>
        <Col>
          <Text level={6} color='Text3'>
            {data?.length || 0} รายการ
          </Text>
        </Col>
      </Row>
      <ConfigProvider
        theme={{
          components: {
            Table: {
              headerBg: "#F3F6F9",
              headerColor: "black",
              fontFamily: "IBM Plex Sans Thai",
              fontSize: 15,
            },
          },
        }}
      >
        <Table
          columns={columns}
          dataSource={data || []}
          pagination={false}
          locale={{
            emptyText: () => (
              <div
                style={{
                  height: "300px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Col>
                  <img src={image.emptyTableBrand} alt='empty_table' />
                </Col>
                <div style={{ height: "15px" }}></div>
                <Col>
                  <div style={{ fontSize: "15px" }}>ไม่มีรายการ</div>
                </Col>
              </div>
            ),
          }}
        />
      </ConfigProvider>
    </>
  );
};

const SectionOrderShop = ({
  data,
  company,
  rounds,
  currentRound,
}: {
  data: any;
  company: any;
  rounds: any;
  currentRound: any;
}) => {
  const [searchText, setSearchText] = useState("");
  const [searchRound, setSearchRound] = useState<number | null>(null);

  const searchShop = useMemo(() => {
    return data.filter((item: any) => {
      const matchOrder =
        !searchText || `${item.orderNo}`.toLowerCase().includes(searchText.toLowerCase());
      const matchRound = !searchRound || `${item.roundNo}` === `${searchRound}`;
      return matchOrder && matchRound;
    });
  }, [data, searchText, searchRound]);

  const onSearchOrder = (searchValue: string, round: any) => {
    setSearchText(searchValue);
    setSearchRound(round);
  };

  const column = [
    {
      title: "Order No.",
      dataIndex: "orderNo",
      key: "orderNo",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{value}</Text>
              <Text color='Text3'>{dayjs(row?.createdAt).format("DD/MM/YYYY HH:mm")}</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "รอบ",
      dataIndex: "roundNo",
      key: "roundNo",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>รอบที่ {value}</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ยอดสั่งซื้อ (฿)",
      dataIndex: "totalPrice",
      key: "totalPrice",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{numberFormatter(value, 2)}</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "สถานะ",
      dataIndex: "status",
      key: "status",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text
                level={5}
                fontWeight={700}
                style={{
                  color: ORDER_STATUS[value]?.text_color,
                  backgroundColor: ORDER_STATUS[value]?.color,
                  padding: "3px 8px 2px 8px",
                  borderRadius: 4,
                  textAlign: "center",
                  fontSize: 14,
                }}
              >
                {getOrderStatus(value, company, row?.isOverCredit) || "-"}
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      width: "8%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <ActionBtn
                onClick={() => {
                  window.open(`/order/${row.orderId}`, "_blank");
                }}
                icon={<UnorderedListOutlined />}
              />
            </FlexCol>
          ),
        };
      },
    },
  ];

  return (
    <Card>
      <div style={{ marginBottom: "10px" }}>
        <Text fontWeight={700} level={4}>
          รายการคำสั่งซื้อ
        </Text>
      </div>
      <Row justify={"space-between"} gutter={8} style={{ paddingBottom: "16px" }}>
        <Col span={8}>
          <Input
            value={searchText}
            placeholder='ค้นหารหัสคำสั่งซื้อ'
            style={{ width: "100%", height: "40px" }}
            suffix={<SearchOutlined />}
            allowClear
            onChange={(e) => {
              const value = e.target.value.replace(/[^0-9]/g, "");
              onSearchOrder(value, searchRound);
            }}
          />
        </Col>
        {currentRound === "ALL" && (
          <Col span={3}>
            <Select
              value={searchRound}
              allowClear
              options={
                rounds?.map((round) => ({
                  label: `รอบที่ ${round.roundNo}`,
                  value: round.roundNo,
                  key: round.roundNo,
                })) || []
              }
              placeholder='เลือกรอบ'
              style={{ width: "100%", height: "40px" }}
              onChange={(e) => {
                onSearchOrder(searchText, e);
              }}
            />
          </Col>
        )}
        <Col flex='1' style={{ paddingTop: "8px", textAlign: "right" }}>
          <Text color='Text3'>{searchShop?.length || 0} รายการ</Text>
        </Col>
      </Row>
      <ConfigProvider
        theme={{
          components: {
            Table: {
              headerBg: "#F3F6F9",
              headerColor: "black",
              fontFamily: "IBM Plex Sans Thai",
              fontSize: 15,
              //rowHoverBg: "none",
            },
          },
        }}
      >
        <Table
          columns={column}
          dataSource={searchShop || []}
          pagination={false}
          scroll={{
            y: 400,
          }}
          locale={{
            emptyText: () => (
              <div
                style={{
                  height: "300px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Col>
                  <img src={image.emptyTableBrand} alt='empty_table' />
                </Col>
                <div style={{ height: "15px" }}></div>
                <Col>
                  <div style={{ fontSize: "15px" }}>ไม่มีรายการ</div>
                </Col>
              </div>
            ),
          }}
        />
      </ConfigProvider>
    </Card>
  );
};
